/* TEGSUMI テーマ共通スクリプト：ヘッダー操作・多言語切替・Ajaxカート・サイト内検索。
   多言語は「日本語を Liquid で出力 → 他言語は辞書（tegsumi-i18n.js）で置き換え」方式（デモと同じ辞書）。 */
(function () {
  'use strict';
  const I = window.TEGSUMI_I18N || { ui: {}, nav: {} };
  const NAMES = window.TEGSUMI_NAMES || {};
  const SHOP = window.TEGSUMI_SHOP || { routes: {} };
  SHOP.routes.root = (SHOP.routes.root || '/').replace(/\/?$/, '/');
  const LANGS = ['ja', 'en', 'ko', 'zh'];
  const STORE_KEY = 'tegsumi-lang';
  function localizedUrl(value) {
    const root = SHOP.routes.root || '/';
    if (root === '/' || typeof value !== 'string' || value.startsWith(root) || !/^\/(pages|products|collections|blogs|policies|search|cart|account|contact)(\/|\?|#|$)/.test(value)) return value;
    return root + value.slice(1);
  }
  Object.keys(SHOP.links || {}).forEach(k => { SHOP.links[k] = localizedUrl(SHOP.links[k]); });

  /* ---------- 言語 ---------- */
  /* The native Shopify URL locale is authoritative. A saved preference or legacy
     ?lang= query must never change Japanese URLs into a different language. */
  const localeLanguage = String(SHOP.locale || document.documentElement.lang || 'ja').toLowerCase().split('-')[0];
  const lang = LANGS.includes(localeLanguage) ? localeLanguage : 'ja';
  try { localStorage.setItem(STORE_KEY, lang); } catch (e) { /* private mode */ }
  document.documentElement.lang = lang === 'zh' ? 'zh-CN' : lang;

  /* app.js の nameParts() と同じ規則：商品名を「主名／補足」に分ける */
  function nameParts(title) {
    const t = String(title || '').trim();
    let m;
    if ((m = t.match(/^(.+?)\s*[｜|]\s*(.+)$/))) return [m[1], m[2]];
    if ((m = t.match(/^(≪.+?≫)\s*(.+)$/))) return [m[2], m[1]];
    if ((m = t.match(/^(.+?)\s*(（.+）)$/))) return [m[1], m[2]];
    if ((m = t.match(/^(.+?)[\s　]+((?:詰替え|＜|리필|补充装|REFILL).+)$/))) return [m[1], m[2]];
    return [t, ''];
  }
  function tr(key) {
    if (key.startsWith('nav:')) {
      const hit = I.nav && I.nav[key];
      if (hit) return hit[lang] || hit.ja;
      const names = NAMES[key.slice(4)];
      return names ? nameParts(names[lang] || names.ja)[0] : null;
    }
    if (key.startsWith('cat.')) {
      const hit = I.cat && I.cat[key.slice(4)];
      return hit ? hit[lang] || hit.ja : null;
    }
    if (key.startsWith('nav.')) {
      const hit = I.nav && I.nav[key.slice(4)];
      return hit ? hit[lang] || hit.ja : null;
    }
    const hit = (I.ui && I.ui[key]) || (I.nav && I.nav[key]);
    return hit ? hit[lang] || hit.ja : null;
  }
  const T = (key, fallback) => (lang === 'ja' ? fallback : tr(key)) || fallback || key;

  function applyLanguage(root) {
    root = root || document;
    root.querySelectorAll('a[href^="/"],form[action^="/"]').forEach(el => {
      const attr = el.tagName === 'FORM' ? 'action' : 'href';
      el.setAttribute(attr, localizedUrl(el.getAttribute(attr)));
    });
    if (lang !== 'ja') {
      root.querySelectorAll('[data-i18n]').forEach((el) => { const v = tr(el.dataset.i18n); if (v) el.textContent = v; });
      root.querySelectorAll('[data-i18n-label]').forEach((el) => { const v = tr(el.dataset.i18nLabel); if (v) el.setAttribute('aria-label', v); });
      root.querySelectorAll('[data-i18n-placeholder]').forEach((el) => { const v = tr(el.dataset.i18nPlaceholder); if (v) el.setAttribute('placeholder', v); });
      /* 商品名（data-product-name="ハンドル"、data-part="main|sub"） */
      root.querySelectorAll('[data-product-name]').forEach((el) => {
        const names = NAMES[decodeURIComponent(el.dataset.productName)];
        if (!names) return;
        const parts = nameParts(names[lang] || names.ja);
        el.textContent = el.dataset.part === 'sub' ? parts[1] : parts[0];
      });
    }
    document.querySelectorAll('[data-lang-name]').forEach((el) => (el.textContent = (I[lang] || I.ja || {}).name || lang));
    document.querySelectorAll('[data-lang-code]').forEach((el) => (el.textContent = lang.toUpperCase()));
    document.querySelectorAll('[data-action="language"]').forEach((b) => b.classList.toggle('active', b.dataset.language === lang));
  }
  function setLanguage(next) {
    if (!LANGS.includes(next)) return;
    try { localStorage.setItem(STORE_KEY, next); } catch (e) { /* ignore */ }
    const u = new URL(location.href);
    u.searchParams.delete('lang');
    const code = (SHOP.languages || []).find((v) => v.split('-')[0] === next);
    const form = document.getElementById('TEGSUMILocalization');
    if (code && form) {
      form.elements.language_code.value = code;
      form.elements.return_to.value = u.pathname + u.search + u.hash;
      form.submit();
      return;
    }
    // If the native form is absent during an editor reload, follow Shopify's
    // alternate URL instead of rendering another language at the current URL.
    const alternate = [...document.querySelectorAll('link[rel="alternate"][hreflang]')]
      .find(link => link.hreflang.toLowerCase().split('-')[0] === next);
    if (alternate) {
      const target = new URL(alternate.href, location.origin);
      target.search = u.search;
      target.hash = u.hash;
      location.href = target.toString();
      return;
    }
    location.href = u.toString();
  }

  /* ---------- ヘッダー ---------- */
  let closeTimer, openTimer;
  const hoverMenus = () => matchMedia('(hover:hover) and (min-width:901px)').matches;
  function closeMenus() {
    clearTimeout(closeTimer); clearTimeout(openTimer);
    document.querySelectorAll('.nav-item.open').forEach((item) => {
      item.classList.remove('open');
      const t = item.querySelector('.nav-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  function openMenu(item) {
    closeMenus();
    item.classList.add('open');
    const t = item.querySelector('.nav-toggle');
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  function closeNavigation() {
    closeMenus();
    const h = document.querySelector('.site-header');
    if (h) h.classList.remove('nav-open');
    const b = document.querySelector('.mobile-nav-toggle');
    if (b) b.setAttribute('aria-expanded', 'false');
  }
  function bindHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    header.querySelectorAll('.has-dropdown').forEach((item) => {
      item.addEventListener('pointerenter', (e) => { if (e.pointerType === 'touch' || !hoverMenus()) return; clearTimeout(closeTimer); clearTimeout(openTimer); openTimer = setTimeout(() => openMenu(item), 100); });
      item.addEventListener('pointerleave', (e) => { if (e.pointerType === 'touch' || !hoverMenus()) return; clearTimeout(openTimer); closeTimer = setTimeout(closeMenus, 200); });
      item.addEventListener('focusout', (e) => { if (matchMedia('(min-width:901px)').matches && !item.contains(e.relatedTarget)) closeMenus(); });
      const toggle = item.querySelector('.nav-toggle');
      if (toggle) toggle.addEventListener('keydown', (e) => { if (e.key === 'ArrowDown') { e.preventDefault(); openMenu(item); const f = item.querySelector('.mega-column h3 a,.mega-product'); if (f) f.focus(); } });
    });
    header.querySelectorAll('.main-nav>a').forEach((a) => a.addEventListener('pointerenter', () => { if (matchMedia('(min-width:901px)').matches) closeMenus(); }));
    header.addEventListener('click', (e) => { if (e.target.closest('.main-nav a')) closeNavigation(); });
    header.addEventListener('focusout', (e) => { if (e.relatedTarget && !header.contains(e.relatedTarget)) closeNavigation(); });
  }

  /* ---------- カート（Shopify Ajax Cart API） ---------- */
  const cartCounts = () => document.querySelectorAll('[data-cart-count]');
  function setCount(n) { cartCounts().forEach((el) => (el.textContent = n)); }
  async function fetchCart() {
    const r = await fetch((SHOP.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!r.ok) throw new Error('cart fetch failed');
    return r.json();
  }
  async function addToCart(id, quantity) {
    const r = await fetch(SHOP.routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: Number(quantity) || 1 })
    });
    if (!r.ok) throw new Error('cart add failed');
    const cart = await fetchCart();
    setCount(cart.item_count);
    toast(T('added', 'カートに追加しました'));
    return cart;
  }
  function toast(message) {
    const n = document.createElement('div');
    n.className = 'toast';
    n.setAttribute('role', 'status');
    n.textContent = message;
    document.body.append(n);
    setTimeout(() => n.remove(), 2800);
  }

  /* ---------- サイト内検索（予測検索） ---------- */
  let searchTimer;
  function bindSearch() {
    const input = document.getElementById('search-input');
    const out = document.getElementById('search-results');
    if (!input || !out) return;
    input.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = input.value.trim();
      if (!q) { out.classList.add('hidden'); return; }
      searchTimer = setTimeout(async () => {
        try {
          const url = `${SHOP.routes.suggest || '/search/suggest.json'}?q=${encodeURIComponent(q)}&resources[type]=product,article&resources[limit]=6`;
          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          let r;
          if (response.ok) {
            const res = await response.json();
            r = (res.resources && res.resources.results) || {};
          } else {
            /* 日本語など予測検索の未対応言語では通常検索を使う。 */
            const fallbackUrl = `${SHOP.routes.search || '/search'}?q=${encodeURIComponent(q)}&type=product,article,page&section_id=tegsumi-search-results`;
            const fallback = await fetch(fallbackUrl, { headers: { Accept: 'text/html' } });
            if (!fallback.ok) throw new Error('search failed');
            const doc = new DOMParser().parseFromString(await fallback.text(), 'text/html');
            const data = JSON.parse(doc.querySelector('[data-tegsumi-search-results]').textContent);
            r = {products:data.results.filter(x=>x.type==='product'),articles:data.results.filter(x=>x.type!=='product')};
          }
          if (input.value.trim() !== q) return;
          const escape = s => String(s || '').replace(/[&<>"']/g, x => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[x]));
          const rows = [
            ...(r.products || []).map((p) => `<a class="search-result" href="${escape(p.url)}"><span data-product-name="${encodeURIComponent(p.handle || '')}" data-part="main">${escape(nameParts(p.title)[0])}</span></a>`),
            ...(r.articles || []).map((a) => `<a class="search-result" href="${escape(a.url)}"><span>${escape(a.title)}</span></a>`)
          ];
          out.innerHTML = rows.length ? rows.join('') : `<div class="search-result"><span>${T('noResults', '該当する商品・記事が見つかりません。')}</span></div>`;
          out.classList.remove('hidden');
          applyLanguage(out);
        } catch (e) {
          if (input.value.trim() !== q) return;
          const link = document.createElement('a');
          link.className = 'search-result';
          link.href = `${SHOP.routes.search || '/search'}?q=${encodeURIComponent(q)}`;
          link.textContent = ({ja:'検索結果を見る',en:'View search results',ko:'검색 결과 보기',zh:'查看搜索结果'})[lang];
          out.replaceChildren(link);out.classList.remove('hidden');
        }
      }, 200);
    });
  }

  /* ---------- クリック（data-action） ---------- */
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.site-header')) closeNavigation();
    const e = event.target.closest('[data-action]');
    if (!e) return;
    const a = e.dataset.action;
    if (a === 'toggle-menu') { const item = e.closest('.nav-item'); item.classList.contains('open') ? closeMenus() : openMenu(item); }
    if (a === 'toggle-navigation') { const header = e.closest('.site-header'); const open = !header.classList.contains('nav-open'); closeMenus(); header.classList.toggle('nav-open', open); e.setAttribute('aria-expanded', String(open)); }
    if (a === 'toggle-search') { closeNavigation(); document.getElementById('header-search').classList.toggle('open'); setTimeout(() => { const i = document.getElementById('search-input'); if (i) i.focus(); }, 0); }
    if (a === 'toggle-language') e.closest('.language-select').classList.toggle('open');
    if (a === 'language') setLanguage(e.dataset.language);
    if (a === 'add-cart') {
      event.preventDefault();
      const qtyEl = e.dataset.quantity === 'detail' ? document.getElementById('quantity') : null;
      const qty = qtyEl ? Number(qtyEl.value || qtyEl.textContent) : 1;
      e.disabled = true;
      Promise.resolve(e.dataset.variant || variantForSlug(e.dataset.slug))
        .then((id) => addToCart(id, qty))
        .catch(() => toast(T('error', 'カートに追加できませんでした')))
        .finally(() => (e.disabled = false));
    }
    if (a === 'cart-qty') {
      event.preventDefault();
      e.disabled = true;
      changeCartLine(e.dataset.line, e.dataset.quantity).catch(() => { toast(T('error', 'カートを更新できませんでした')); e.disabled = false; });
    }
  });

  /* デモの商品 slug → Shopify の販売可能な最初のバリアント ID（ハンドルが違う商品は TEGSUMI_HANDLES で対応） */
  const variantCache = {};
  function variantForSlug(slug) {
    const handle = (window.TEGSUMI_HANDLES || {})[slug] || slug;
    const cur = window.TEGSUMI_PRODUCT;
    if (cur && cur.handle === handle && cur.variantId) return cur.variantId;
    if (!variantCache[handle]) {
      variantCache[handle] = fetch(`${SHOP.routes.root || '/'}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => { if (!r.ok) throw new Error('product not found'); return r.json(); })
        .then((p) => (p.variants.find((v) => v.available) || p.variants[0]).id);
    }
    return variantCache[handle];
  }

  /* カートページ：数量変更・削除 → /cart/change.js → ページ内のカート部分だけ再取得して差し替える */
  async function changeCartLine(line, quantity) {
    const r = await fetch(SHOP.routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    });
    if (!r.ok) throw new Error('cart change failed');
    const cart = await r.json();
    setCount(cart.item_count);
    const html = await (await fetch(location.pathname, { headers: { Accept: 'text/html' }, cache: 'no-store' })).text();
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-root]');
    const cur = document.querySelector('[data-cart-root]');
    if (next && cur) { cur.replaceWith(next); applyLanguage(next); }
  }

  /* 商品ページ（通常フォーム）のバリアント切替 */
  document.addEventListener('change', (event) => {
    const sel = event.target.closest('form[data-product-form] select[data-option-index]');
    if (!sel) return;
    const form = sel.form;
    const json = document.querySelector('script[data-product-variants]');
    if (!json) return;
    const picked = [...form.querySelectorAll('select[data-option-index]')].map((x) => x.value);
    const v = JSON.parse(json.textContent).find((x) => picked.every((val, i) => x['option' + (i + 1)] === val));
    const idInput = form.querySelector('[data-variant-id]');
    const btn = form.querySelector('button[type=submit], button[disabled]');
    if (v && idInput) idInput.value = v.id;
    if (btn && v) { btn.disabled = !v.available; btn.textContent = v.available ? T('addCart', 'カートに入れる') : T('soldOut', '売り切れ'); btn.type = v.available ? 'submit' : 'button'; }
  });

  /* 確認ダイアログ付きフォーム（住所の削除など） */
  document.addEventListener('submit', (event) => {
    const f = event.target.closest('form[data-confirm]');
    if (!f) return;
    if (!confirm(T(f.dataset.i18nConfirm, f.dataset.confirm))) event.preventDefault();
  });

  /* ログイン画面の「ログイン／パスワード再設定」切替（#recover で再設定を表示） */
  function bindAccountSwitch() {
    const cards = document.querySelectorAll('[data-account-mode]');
    if (!cards.length) return;
    const show = () => {
      const mode = location.hash === '#recover' || new URLSearchParams(location.search).get('mode') === 'recover' ? 'recover' : 'login';
      cards.forEach((c) => (c.hidden = c.dataset.accountMode !== mode));
    };
    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-account-switch]');
      if (!a) return;
      e.preventDefault();
      history.replaceState(null, '', a.dataset.accountSwitch === 'recover' ? '#recover' : location.pathname);
      show();
    });
    /* 再設定メール送信後は同じ画面に戻るので、送信済みメッセージが見えるよう再設定側を開く */
    if (document.querySelector('#recover .form-status')) history.replaceState(null, '', '#recover');
    addEventListener('hashchange', show);
    show();
  }

  /* 商品ページの購入フォームは Ajax で追加（失敗時は通常送信にフォールバック） */
  document.addEventListener('submit', (event) => {
    const f = event.target.closest('form[data-product-form]');
    if (!f) return;
    event.preventDefault();
    const id = (f.querySelector('[name="id"]') || {}).value;
    const q = (f.querySelector('[name="quantity"]') || {}).value;
    addToCart(id, q).catch(() => f.submit());
  });

  /* ---------- 公開API ---------- */
  window.TEGSUMI = { lang: () => lang, T, nameParts, applyLanguage, addToCart, fetchCart, toast, setCount };

  function init() {
    bindHeader();
    bindSearch();
    bindAccountSwitch();
    applyLanguage();
    document.dispatchEvent(new CustomEvent('tegsumi:ready', { detail: { lang } }));
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
